
theme.CollectionTemplateSection = new (function () {
  this.onSectionLoad = function (container) {
    this.namespace = theme.namespaceFromSection(container);
    this.$container = $(container);

    this.filterer = new theme.LoadFilterer(this);

    // button subcollection link hide/reveal
    $(window).on(
      "debouncedresize" + this.namespace,
      this.functions.truncateButtonSubcollections.bind(this)
    );
    this.functions.truncateButtonSubcollections.call(this);

    // gallery subcollection carousel
    var $subcollectionGallery = $(
      ".subcollection-links--gallery .gallery",
      container
    );
    $subcollectionGallery
      .on("init", function () {
        $(".lazyload--manual", this)
          .removeClass("lazyload--manual")
          .addClass("lazyload");
      })
      .slick({
        autoplay: false,
        fade: false,
        infinite: false,
        swipeToSlide: true,
        slidesToShow: Math.min(
          4,
          $(".subcollection-links--gallery .gallery__item", container).length
        ),
        slidesToScroll: 1,
        useTransform: true,
        arrows: true,
        dots: false,
        prevArrow:
          '<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="' +
          theme.strings.previous +
          '">' +
          theme.icons.chevronLeft +
          "</button>",
        nextArrow:
          '<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="' +
          theme.strings.next +
          '">' +
          theme.icons.chevronRight +
          "</button>",
        rtl: document.querySelector("html[dir=rtl]") ? true : false,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: Math.min(
                3,
                $(".subcollection-links--gallery .gallery__item", container)
                  .length
              ),
            },
          },

          {
            breakpoint: 768,
            settings:
              $subcollectionGallery.data("mobile-item-count") == "hide"
                ? "unslick"
                : {
                    slidesToShow:
                      $subcollectionGallery.data("mobile-item-count"),
                  },
          },
        ],
      });
  };

  this.onSectionUnload = function (container) {
    this.filterer.destroy();
    $(".subcollection-links__expander", this.$container).off("click");
    $(".slick-slider", container).slick("unslick").off("init");
    $(window).off(this.namespace);
  };

  this.functions = {
    truncateButtonSubcollections: function truncateButtonSubcollections() {
      var $subcollections = $(".subcollection-links--buttons", this.$container);
      if ($subcollections.css("display") == "flex") {
        var limit = 4;
        var $btns = $subcollections.find(".btn");
        if (
          $btns.length > limit &&
          $subcollections.find(".subcollection-links__expander").length === 0
        ) {
          $btns.slice(limit - 1).hide();
          $(
            '<a href="#" class="btn btn--tertiary subcollection-links__expander">'
          )
            .text(theme.strings.collections_general_see_all_subcollections)
            .appendTo($subcollections)
            .on("click", function (evt) {
              evt.preventDefault();
              $(this).siblings().show();
              $(this).remove();
            });
        }
      } else if (
        $subcollections.find(".subcollection-links__expander").length
      ) {
        $subcollections
          .find(".subcollection-links__expander")
          .siblings()
          .show();
        $subcollections.find(".subcollection-links__expander").remove();
      }
    },
  };
})();



theme.Sections.register(
  "collection-template",
  theme.CollectionTemplateSection,
  { deferredLoad: false }
);
